import { ArrowLeftIcon, ArrowRightIcon, Button, DatePicker } from '@bp/ui-components';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useUserConfigContext } from '../../hooks/useUserConfigContext';
import { getDayOfWeekAsString } from '../../utils/dateCalculations';
import { lowercaseFirstLetter } from '../../utils/stringHelper';
import { NavigationTabs } from '../NavigationTabs/NavigationTabs';
import { useSubstitutionStore } from '../Substitutions/SubstitutionProvider';
import styles from './SubstitutionsTopBar.module.scss';

type SubstitutionsTopBarProps = {
  baseSlug: string;
};

export const SubstitutionsTopBar = observer(({ baseSlug }: SubstitutionsTopBarProps) => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentSchoolYear = useUserConfigContext().selectedSchoolYear;

  const store = useSubstitutionStore();

  const isSchoolEventPath = location.pathname.endsWith(t('routes.schoolEvents.slug'));

  return (
    <div className={styles['substitutions-top-bar']}>
      <NavigationTabs
        tabs={[
          {
            title: t('schoolEvents.title', { count: 2, context: 'short' }),
            path: `/${baseSlug}/${t('routes.schoolEvents.slug')}`,
            active: isSchoolEventPath,
          },
          {
            title: t('absences.title', { count: 2 }),
            path: `/${baseSlug}/${t('routes.absences.slug')}`,
            active: location.pathname.endsWith(t('routes.absences.slug')),
          },
          {
            title: t('substitutions.title', { count: 2 }),
            path: `/${baseSlug}/${t('routes.substitutions.slug')}`,
            active: location.pathname.endsWith(t('routes.substitutions.slug')),
          },
        ]}
        size='xxl'
        hideBorder
        className={styles.tabs}
      />
      {!isSchoolEventPath && (
        <div className={styles.date}>
          <div>
            {lowercaseFirstLetter(
              t('absences.for', {
                for: getDayOfWeekAsString(store.selectedDay),
              }),
            )}
          </div>
          <Button
            name='decrease'
            hierarchy='secondary'
            onClick={() => store.setSelectedDay(store.selectedDay.subtract(1, 'day'))}
            icon={<ArrowLeftIcon />}
          />
          <DatePicker
            className={styles.picker}
            onChange={(e) => {
              store.setSelectedDay(dayjs(e));
            }}
            name='date'
            value={store.selectedDay.toDate()}
            dense
            minDate={dayjs(currentSchoolYear?.start).toDate()}
            maxDate={dayjs(currentSchoolYear?.end).toDate()}
          />
          <Button
            name='increase'
            hierarchy='secondary'
            onClick={() => store.setSelectedDay(store.selectedDay.add(1, 'day'))}
            icon={<ArrowRightIcon />}
          />
        </div>
      )}
    </div>
  );
});
